import Radio from './Radio';
import RadioGroup from './RadioGroup';
import RadioButton from './RadioButton';

Radio.Group = RadioGroup;
Radio.Button = RadioButton;
export { RadioGroup, RadioButton };
export default Radio;



// WEBPACK FOOTER //
// ./src/radio/index.js